<template>
  <div :style="containerStyle" class="hero-image-container">
    <!-- 動画の場合 -->
    <video
      v-if="mediaType === 'video'"
      :src="isMobileDevice ? mobileVideoUrl : desktopVideoUrl"
      class="hero-media"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
    ></video>
    <!-- 静止画の場合 -->
    <img
      v-else
      :src="isMobileDevice ? mobileMediaUrl : desktopMediaUrl"
      :alt="isMobileDevice ? 'Mobile Hero Media' : 'Desktop Hero Media'"
      class="hero-media"
    />
    <div class="overlay">
      <img :src="logoUrl" class="logo" alt="Logo" />
      <div class="info-text">
        <div class="text-item">
          <p
            class="text-body-1 text-sm-h6 text-center date-text"
            v-html="t('heroImage.date')"
          ></p>
        </div>
        <!-- <v-btn
          size="x-large"
          :ripple="false"
          :href="t('heroImage.link')"
          elevation="0"
          variant="plain"
          target="_blank"
        >
          <span
            v-html="t('heroImage.button')"
            class="text-caption text-sm-body-2 text-md-body-1"
            style="text-transform: none"
          ></span>
          <SvgIcon
            type="mdi"
            :path="mdiOpenInNew"
            size="16"
            class="ml-2"
          />
        </v-btn> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import isMobile from "ismobilejs";
import { useI18n } from "vue-i18n";
import { mdiOpenInNew, mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { getBasePath } from '@/utils/basePath';

// プロパティの定義
const props = defineProps({
  logoUrl: {
    type: String,
    required: true,
  },
  mediaType: {
    type: String,
    default: 'image', // 'image' または 'video'
    validator: (value) => ['image', 'video'].includes(value)
  },
  mobileMediaUrl: {
    type: String,
    required: false,
  },
  desktopMediaUrl: {
    type: String,
    required: false,
  },
  mobileVideoUrl: {
    type: String,
    required: false,
  },
  desktopVideoUrl: {
    type: String,
    required: false,
  }
});

const isMobileDevice = ref(isMobile(window.navigator.userAgent).any);

// basePathユーティリティからベースパスを取得
const basePath = computed(() => getBasePath());

// メディアURL（propsから取得）
const mobileMediaUrl = computed(() => props.mobileMediaUrl);
const desktopMediaUrl = computed(() => props.desktopMediaUrl);
const mobileVideoUrl = computed(() => props.mobileVideoUrl);
const desktopVideoUrl = computed(() => props.desktopVideoUrl);

const { t } = useI18n();

const aspectRatio = computed(() => {
  return isMobileDevice.value ? "140%" : "56.25%"; // 9:16 か 16:9 のアスペクト比
});

const containerStyle = computed(() => {
  return {
    paddingTop: aspectRatio.value,
  };
});

</script>

<style scoped lang="scss">
.hero-image-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.hero-media {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left;
}

:deep(.v-img__img) {
  object-position: left bottom;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 半透明の黒いオーバーレイ */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  height: auto;
  aspect-ratio: 910/1276; // ロゴの縦横比を固定（実際のロゴの縦横比に合わせて調整してください）
  object-fit: contain; // アスペクト比を維持しながら収まるように
  z-index: 2;
  @media screen and (min-width: 600px) {
    top: 50%;
    left: auto;
    transform: translate(0, -50%);
    width: min(500px, 80vw);
    max-height: 80vh;
  }
  @media screen and (min-width: 900px) {
    width: min(500px, 80vw);
    max-height: 80vh;
  }
  @media screen and (min-width: 1200px) {
    width: min(500px, 80vw);
    max-height: 80vh;
  }
  @media screen and (min-width: 1600px) {
    width: min(600px, 80vw);
    max-height: 80vh;
  }
}
.info-text {
  position: absolute;
  bottom: 2%; /* 下部に固定 */
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 2;
  color: white;
  font-size: 1.5em;
  text-align: center;
}

@media (min-width: 601px) {
  .info-text {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
    text-align: center;
  }
}

.hero-image-container {
  margin-top: -64px;
}

.date-text {
  white-space: pre-line;
  line-height: 1.4;
}
</style>
